import PropTypes from "prop-types"
import React, {useState, useEffect} from "react"
import { connect } from "react-redux"
import { withRouter , Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import logoSm from "../../assets/images/logo-sm.png"
import logoDark from "../../assets/images/logo-dark.png"
import logoLight from "../../assets/images/logo-light.png"
import CMSLogo from "../../assets/images/cms-logo.png"

const Sidebar = props => {
  const [isMerchantLoggedIn, setIsMerchant] = useState(false)
  useEffect(() => {
    const isMerchant = localStorage?.getItem("isMerchant")
    console.log("Checking merchant flag", isMerchant)
    if(isMerchant == "true"){
      setIsMerchant(true)
      // document.getElementsByClassName("vertical-menu").style.display = "block"
    }else{
      setIsMerchant(false)
    }
  }, [])
  return (
    <React.Fragment>
        <div className="vertical-menu" style={{display: isMerchantLoggedIn ? "none" : "block"}}>
        <div className="navbar-brand-box">
          {/* <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logoSm} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={""} alt="" height="20" />
            </span>
          </Link> */}

          <Link to="/" className="logo logo-light">
            {/* <span className="logo-sm">
              <img src={logoSm} alt="" height="22" />
            </span> */}
            <span className="logo-lg">
              <img src={CMSLogo} alt="" height="40" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(mapStatetoProps,{})(withRouter(withTranslation()(Sidebar)))